<template>
  <div class="deliverable-block project-block" :class="{ 'dup-selected': isSelected, 'dup-deselected': !isSelected }"
    :id="'dup__deliverable__' + deliverable.id">
    <div class="delv-block-resp">
      <div class="side-box" :class="{ 'no-border-bottom-left-radius': expanded && hasTasks }">
        <button type="button" class="side-box-btn" @click.stop="toggleSelection">
          <b-form-checkbox :checked="isSelected" @change="toggleSelection"
            @click.native.stop="onDuplicateCheckboxClick">Duplicate</b-form-checkbox>
        </button>
        <button v-if="!isOrganicSocialMedia" class="side-box-btn" @click.stop="toggleDetailExpand">{{ expanded? "Close": "Preview" }}</button>
        <button v-if="isOrganicSocialMedia && deliverable.posts_count > 0" class="side-box-btn"
          :disabled="loadingPosts"
          @click.stop="togglePostSelectionExpand">{{ postActionLabel }}</button>
      </div>
      <div class="d-flex flex-row dbox-wrapper">
        <!-- <div class="dup-close-btn" v-show="localExpanded" @click.stop="closeExpand">
           <img src="@/csmworkflow/img/close.svg" />
        </div> -->
        <div class="dbox-left-side dleft-inner-wrap">
          <!-- Top row - same structure as deliverable tab -->
          <div class="top-row">
            <div class="data-items">
              <span>{{ deliverable.template_title || 'Deliverable' }}</span>
            </div>
            <div class="data-items hide-mobile" v-if="deliverable.task_count > 0">
              <!-- <span class="dup-task-count-badge">
                <i class="fa fa-tasks"></i> {{ deliverable.task_count }} {{ deliverable.task_count === 1 ? 'TASK' :
                'TASKS' }}
              </span> -->
              <span>
                {{ deliverable.task_count }} {{ deliverable.task_count === 1 ? 'TASK' :
                  'TASKS' }}
              </span>
            </div>
            <div class="data-items hide-mobile">
              <span>CREATED: </span>
              {{ deliverable.created_at | moment("DD MMM, YYYY") }}
            </div>

          </div>

          <!-- Deliverable Type Icon -->
          <!-- <DeliverableTypeIcon :deliverableTypeId="deliverable.deliverable_template_id" /> -->

          <!-- Main listing row -->
          <div class="row listing-row">
            <div class="col-md-12 titles">
              <!-- Title -->
              <div class="deliverable-title edit-d-title dup-deliverable-title">
                <!-- <b-form-checkbox class="dup-checkbox" :checked="isSelected" @change="toggleSelection"
                  @click.native.stop></b-form-checkbox> -->
                {{ deliverable.title }}
                <span v-if="isOrganicSocialMedia && deliverable.posts_count > 0" class="dup-title-post-count" @click.stop="toggleTitleAction">
                  <i class="fa fa-share-alt"></i> {{ selectedPostCount }} / {{ totalPostCount }} {{ postCountLabel }}
                </span>
                <!-- <button v-if="isOrganicSocialMedia && deliverable.posts_count > 0" type="button"
                  class="btn btn-sm btn-success dup-select-posts-inline-btn" @click.stop="openPostSelection">Select
                  post</button> -->
                <!-- <button v-if="!isOrganicSocialMedia" type="button"
                  class="btn btn-sm btn-success dup-view-task-inline-btn" @click.stop="openDeliverableDetail">View
                  task</button> -->
                <!-- <span class="dup-preview-icon" :title="isOrganicSocialMedia ? 'Select posts' : 'Preview deliverable'"
                  @click.stop="isOrganicSocialMedia ? openPostSelection() : openDeliverableDetail()">
                  <i class="fa fa-pencil"></i>
                </span> -->
              </div>
            </div>
            <!-- <div class="col-md-4 infos">
            </div> -->
          </div>
        </div>

        <!-- Right side: Collapse/Expand task button -->
        <div v-if="hasTasks && 0" class="dbox-right-side dright-inner-wrap">
          <div class="collapse-control" @click.stop="toggleExpand">
            <div class="task-exp">
              <span v-if="!expanded">
                <span v-if="deliverable.task_count === 1">{{ deliverable.task_count }}<br> TASK</span>
                <span v-else>{{ deliverable.task_count }}<br> TASKS</span>
                <span class="icon">
                  <img src="/images/chevron-down.svg" />
                </span>
              </span>
              <span v-else>
                <span>CLOSE</span>
                <span class="icon close-collase">
                  <img src="/images/chevron-up.svg" />
                </span>
              </span>
            </div>
            <div class="task-exp exp-mobile">
              <span v-if="!expanded">
                <span class="icon">
                  <img src="/images/chevron-down.svg" />
                </span>
              </span>
              <span v-else>
                <span class="icon close-collase">
                  <img src="/images/chevron-up.svg" />
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Expanded task list -->
    <div v-if="expanded && hasTasks && 0" class="row">
      <div class="col-md-12 task-list-wrapper">
        <div class="side-task-box"></div>

        <div class="task-list-content">
          <!-- Task field labels header -->
          <div id="dup__task__field__labels">
            <div class="field-block d-flex flex-row">
              <div class="field-control-wrapper field-control-wrapper__title no-radius">
                <div class="task-title">
                  <div class="task-table-header__task">
                    Tasks <span class="task-count-second">({{ deliverable.tasks.length }})</span>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__user">
                <div class="task-table-header">
                  <div class="field-label">Assigned to</div>
                </div>
              </div>
              <div v-if="false"
                class="d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__due_date">
                <div class="task-table-header">
                  <div class="field-label">Due Date</div>
                </div>
              </div>
              <div class="d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status">
                <div class="task-table-header">
                  <div class="field-label">Status</div>
                </div>
              </div>
              <div class="d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status_note">
                <div class="task-table-header">
                  <div class="field-label">Notes</div>
                </div>
              </div>
            </div>
          </div>
          <!-- Task rows -->
          <div class="task-fields">
            <div v-for="task in deliverable.tasks" :key="'dup-task-' + task.id" class="d-flex flex-row field-block">
              <div class="field-control-wrapper field-control-wrapper__title no-radius">
                <div class="task-title">
                  <div class="field-wrap">
                    <div>
                      <span class="field-value" :title="task.title">
                        {{ task.title }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__user">
                <div class="custom-title">
                  <div class="field-wrap no-icon">
                    <span class="field-value" v-if="task.user_name">{{ task.user_name }}</span>
                    <span class="field-value text-muted" v-else>—</span>
                  </div>
                </div>
              </div>
              <div v-if="false"
                class="d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__due_date">
                <div class="custom-title">
                  <div class="field-wrap no-icon">
                    <span class="field-value text-muted">No Deadline</span>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status">
                <div class="custom-title">
                  <div class="field-wrap no-icon">
                    <span class="field-value status-field-value"
                      :style="{ backgroundColor: task.status_color || '#778899' }">{{ task.status_name || 'Not Started'
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block field-rows field-control-wrapper field-control-wrapper__status_note">
                <div class="custom-title">
                  <div class="field-wrap no-icon">
                    <span class="field-value dup-notes-value" v-if="task.notes" :title="task.notes">{{ task.notes
                    }}</span>
                    <span class="field-value text-muted" v-else>—</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="expanded && hasTasks"  class="row">
      <div class="col-md-12 task-list-wrapper">
        <div class="side-task-box"></div>

        <div class="task-list-content">
          <DuplicatePostSelection v-if="expanded && activePostDeliverable" :deliverable="activePostDeliverable" @close="closeExpand" />
          <DuplicateDeliverableDetail v-if="expanded && activePreviewDeliverable" :deliverable="activePreviewDeliverable" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeliverableTypeIcon from "../deliverables/DeliverableTypeIcon";
import DuplicatePostSelection from "./DuplicatePostSelection.vue";
import DuplicateDeliverableDetail from "./DuplicateDeliverableDetail.vue";

export default {
  name: "DuplicateDeliverableListItem",
  components: {
    DeliverableTypeIcon,
    DuplicatePostSelection,
    DuplicateDeliverableDetail,
  },
  props: {
    deliverable: {
      type: Object,
      required: true,
    },
    forceExpand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localExpanded: false,
      activePostDeliverable: null,
      activePreviewDeliverable: null,
      loadingPosts: false,
    };
  },
  watch: {
    async forceExpand(val) {
      if(val && !this.activePostDeliverable && (this.isOrganicSocialMedia && this.deliverable.posts_count > 0)){
        await this.ensurePostsLoaded();
        this.activePostDeliverable = this.deliverable;
      }
      if(val && !this.activePreviewDeliverable && !this.isOrganicSocialMedia){
        this.activePreviewDeliverable = this.deliverable;
      }
      this.localExpanded = val;
    },
  },
  computed: {
    isSelected() {
      return this.$store.getters.isDeliverableSelected(this.deliverable.id);
    },
    isOrganicSocialMedia() {
      return this.deliverable.template_slug === "organic-social-media-plan";
    },
    hasTasks() {
      return this.deliverable.tasks && this.deliverable.tasks.length > 0;
    },
    selectedPostCount() {
      return this.getDisplaySelectedPostCount();
    },
    totalPostCount() {
      return this.getDisplayPostTotalCount();
    },
    expanded() {
      return this.localExpanded;
    },
    postActionLabel() {
      if (this.loadingPosts) return "Loading...";
      return this.expanded ? "Close" : "Select Posts";
    },
    postCountLabel() {
      return this.totalPostCount === 1 ? "post" : "posts";
    },
  },
  methods: {
    toggleSelection() {
      this.$store.commit("TOGGLE_DELIVERABLE", this.deliverable.id);
    },
    onDuplicateCheckboxClick(event) {
      if (event.target.closest("input, label")) {
        return;
      }

      this.toggleSelection();
    },
    openDeliverableDetail() {
      this.$emit("open-deliverable-detail", this.deliverable);
    },
    openPostSelection() {
      this.$emit("open-post-selection", this.deliverable);
    },
    isUnlinkedSeriesChild(post) {
      return !!(post && post.social_series_id && !post.is_master && post.manually_updated_at);
    },
    getPostCountOverride(counts, postId, fallback) {
      if (Object.prototype.hasOwnProperty.call(counts, postId)) {
        let count = parseInt(counts[postId], 10);
        return isNaN(count) || count < 0 ? 0 : count;
      }
      return fallback;
    },
    getSeriesMasterIds() {
      if (!this.deliverable || !Array.isArray(this.deliverable.posts)) return new Set();
      return new Set(this.deliverable.posts.filter((post) => post.social_series_id && post.is_master).map((post) => post.id));
    },
    getDisplayPostTotalCount() {
      if (!this.deliverable) return 0;
      if (!Array.isArray(this.deliverable.posts) || !this.deliverable.posts.length) {
        return this.deliverable.posts_count || 0;
      }
      return this.deliverable.posts.filter((post) => !post.social_series_id || !post.is_master).length;
    },
    getDisplaySelectedPostCount() {
      if (!this.deliverable) return 0;
      const selectedIds = this.$store.state.duplicationWizard.selectedSocialMediaPostIds[this.deliverable.id];
      if ((!Array.isArray(this.deliverable.posts) || !this.deliverable.posts.length) && !selectedIds) {
        return this.isSelected ? (this.deliverable.posts_count || 0) : 0;
      }
      const masterIds = this.getSeriesMasterIds();
      return this.getSelectedPostSequence().filter((postId) => !masterIds.has(postId)).length;
    },
    getSelectedPostSequence() {
      if (!this.deliverable || !Array.isArray(this.deliverable.posts)) return [];

      const selectedIds = this.$store.state.duplicationWizard.selectedSocialMediaPostIds[this.deliverable.id] || [];
      const selectedCounts = this.$store.state.duplicationWizard.selectedSocialMediaPostCounts[this.deliverable.id] || {};
      const seriesMap = {};
      const soloPosts = [];

      this.deliverable.posts.forEach((post) => {
        const seriesId = post.social_series_id;
        if (!seriesId || this.isUnlinkedSeriesChild(post)) {
          soloPosts.push(post);
          return;
        }
        if (!seriesMap[seriesId]) {
          seriesMap[seriesId] = { master: null, children: [] };
        }
        if (post.is_master) {
          seriesMap[seriesId].master = post;
        } else {
          seriesMap[seriesId].children.push(post);
        }
      });

      const sequence = [];
      soloPosts.forEach((post) => {
        if (!selectedIds.includes(post.id)) return;
        const count = this.getPostCountOverride(selectedCounts, post.id, 1);
        for (let index = 0; index < count; index++) {
          sequence.push(post.id);
        }
      });

      Object.values(seriesMap).forEach((group) => {
        group.children = group.children.slice().sort((a, b) => {
          const aDate = a.publish_date ? new Date(a.publish_date).getTime() : 0;
          const bDate = b.publish_date ? new Date(b.publish_date).getTime() : 0;
          return aDate - bDate;
        });

        if (!group.master) {
          group.children.forEach((post) => {
            if (selectedIds.includes(post.id)) {
              sequence.push(post.id);
            }
          });
          return;
        }

        if (Object.prototype.hasOwnProperty.call(selectedCounts, group.master.id)) {
          const count = this.getPostCountOverride(selectedCounts, group.master.id, 0);
          if (count > 0) {
            sequence.push(group.master.id);
            for (let index = 0; index < count && group.children.length > 0; index++) {
              sequence.push(group.children[index % group.children.length].id);
            }
          }
          return;
        }

        if (selectedIds.includes(group.master.id)) {
          sequence.push(group.master.id);
        }
        group.children.forEach((post) => {
          if (selectedIds.includes(post.id)) {
            sequence.push(post.id);
          }
        });
      });

      return sequence;
    },
    onTitleClick() {
      this.toggleSelection();
    },
    toggleDetailExpand() {
      this.activePreviewDeliverable = this.deliverable;
      this.activePostDeliverable = null;
      this.localExpanded = !this.localExpanded;
    },
    closeExpand() {
      this.localExpanded = false;
    },
    async ensurePostsLoaded() {
      if (!this.isOrganicSocialMedia || !this.deliverable.posts_count || this.deliverable.posts_loaded) return;

      this.loadingPosts = true;
      try {
        await this.$store.dispatch("fetchDuplicationSocialPosts", this.deliverable.id);
      } catch (error) {
        console.error("Failed to load social posts for duplication:", error);
        throw error;
      } finally {
        this.loadingPosts = false;
      }
    },
    toggleExpand() {
      this.activePreviewDeliverable = this.deliverable;
      this.activePostDeliverable = null;
      this.localExpanded = !this.localExpanded;
    },
    toggleTitleAction() {
      if (this.isOrganicSocialMedia) {
        this.togglePostSelectionExpand();
        return;
      }
      this.toggleDetailExpand();
    },
    async togglePostSelectionExpand(){
      if (!this.localExpanded) {
        try {
          await this.ensurePostsLoaded();
        } catch (error) {
          return;
        }
      }

      this.activePostDeliverable = this.deliverable;
      this.activePreviewDeliverable = null;
      this.localExpanded = !this.localExpanded;
    }
  },
};
</script>

<style lang="scss" scoped>
.deliverable-block {
  padding: 0;

  .top-row {
    margin-left: 0;
    padding-left: 0;
    border-top-left-radius: 0;

    .data-items {
      text-align: left;
      padding: 0 0 0 20px;
    }
  }

  .listing-row {
    margin-right: 0px;
    margin-left: 0px;

    .titles {
      padding: 20px;
      border: 0;
    }
  }

  .delv-block-resp {
    display: flex;

    .side-box {
      width: 140px;
      background-color: #2d2d2d;
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      padding-top: 15px;
    }

    .dbox-wrapper {
      flex: 1;
      position: relative;
      .dup-close-btn{
        position: absolute;
        right: 20px;
        top: -10px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: var(--wf-primary);
        text-align: center;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 16px;
        }
      }
    }
  }

  .side-box-btn {
    border-radius: 10px;
    color: #000;
    font-weight: 600;
    background-color: #fff;
    font-size: 14px;
    padding: 2px 6px;
    width: 110px;
    text-align: center;
  }
}

.dup-selected {
  opacity: 1;
}

.dup-deselected {
  opacity: 0.5;
}

.dup-deselected .top-row {
  filter: grayscale(100%);
}

.dup-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.dup-checkbox .custom-control-label {
  margin-bottom: 0;
}

.dup-checkbox .custom-control-label::before,
.dup-checkbox .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
}

.dup-deliverable-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  cursor: unset;
}

.dup-deliverable-title::after {
  display: none !important;
}

.dup-preview-icon {
  display: inline-block;
  margin-left: auto;
  font-size: 20px;
  opacity: 0.7;
  cursor: pointer;
  vertical-align: middle;
  flex-shrink: 0;
}

.dup-preview-icon:hover {
  opacity: 1;
}

.dup-post-count-badge {
  cursor: pointer;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 3px;
  white-space: nowrap;
}

.dup-post-count-badge:hover {
  background: rgba(255, 255, 255, 0.4);
}

.dup-title-post-count {
  font-size: .9rem;
  font-weight: 600;
  cursor: pointer;
  margin-left: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.dup-title-post-count:hover {
}

.dup-select-posts-inline-btn {
  margin-left: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.dup-view-task-inline-btn {
  margin-left: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.dup-task-count-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 3px;
  white-space: nowrap;
}

.dup-manage-btn {
  font-size: 12px;
  white-space: nowrap;
}

.dup-notes-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  display: inline-block;
}

.no-border-bottom-left-radius {
  border-bottom-left-radius: 0 !important;
}

.task-list-wrapper {
  display: flex;

  .side-task-box {
    flex-shrink: 0;
    height: 100%;
    width: 140px;
    background-color: #2d2d2d;
    border-bottom-left-radius: 15px;
  }

  .task-list-content {
    flex: 1;
    overflow-y: auto;
  }
}

.field-control-wrapper__title {
  .field-wrap {
    margin-left: 0;
    padding-left: 0;
  }
}

#dup__task__field__labels .task-table-header__task {
  font-weight: 600;
  padding: 8px 15px;
  border-bottom: none !important;
  display: flex;
  align-items: center;
  height: 100%;
}

#dup__task__field__labels .task-table-header {
  padding: 8px 10px;
  border-bottom: none !important;
}

#dup__task__field__labels .field-block:first-child .task-table-header {
  border-bottom: none !important;
}

#dup__task__field__labels .field-label {
  font-weight: 600;
}
</style>
